import { render, staticRenderFns } from "./preference-update.vue?vue&type=template&id=1f335abe&scoped=true"
import script from "./preference-update.vue?vue&type=script&lang=js"
export * from "./preference-update.vue?vue&type=script&lang=js"
import style0 from "./preference-update.vue?vue&type=style&index=0&id=1f335abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f335abe",
  null
  
)

export default component.exports